import certificateDownloadReducer from "./certificateDownloadReducer";

const certificateDownloadReducers = {
    certificateDownload: certificateDownloadReducer
}

export default certificateDownloadReducers;